// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indicator[data-v-7be1fe96]{display:none;z-index:1;pointer-events:none;position:absolute;border-radius:3px;height:6px;width:100%;background:rgba(0,0,0,.4)}.indicator.dragBottom[data-v-7be1fe96],.indicator.dragTop[data-v-7be1fe96]{display:block}.indicator.dragTop[data-v-7be1fe96]{top:-2px}.indicator.dragBottom[data-v-7be1fe96]{bottom:-4px}", ""]);
// Exports
module.exports = exports;
